import React, { useEffect, useState } from "react";
import { TextLink } from "@vds/buttons";
import * as Actions from "../../store/actions/global/global";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { helpNavigationHandler } from "../../util/helpURLNavigation";
import { /*chatScript,*/ removeChat } from "../../util/chatBotUtils";
import CPFallbackPage from "./CPFallbackPage";
import PropTypes from "prop-types";

const SomethingWentWrong = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation("loginTranslation");
  const [contactSupportLink, setContactSupportLink] = useState("");

  useEffect(() => {
    removeChat(props.regionId, props.emailAddress);
    sessionStorage.clear();
    setContactSupportLink(helpNavigationHandler(props.regionId, "Customer Portal | Support Cases | Help ", props.accountNumber, true, true));

    return () => {
      props.setRevealPermissionFallBack(false);
      // if (props.emailAddress && (props.regionId === "840" || props.regionId === "124")) {
      //   chatScript(props.firstName, props.surname, props.emailAddress, props.phoneNumber);
      // }
    };
  }, []);

  useEffect(() => {
    document.title = t(`${props.title}`);
  }, [props.title]);

  const handleTryAgain = () => {
    navigate("/login");
  };
  return (
    <div>
      <CPFallbackPage
        windowSize={props.windowSize.width}
        ariaLabel="Something went wrong"
        pageTitle={t("Something went wrong")}
        pageContent={
          <>
            {t("Try again or")}{" "}
            <TextLink
              id="permission-contact-support-link"
              href={contactSupportLink}
              size="small"
              type="standAlone"
              tabIndex="0"
              ariaLabel="contact suppport "
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0077B4", borderColor: "#0077B4" }}
            >
              {t("contact support.")}
            </TextLink>{" "}
          </>
        }
        buttonId="permission-tryagain-button"
        buttonHandler={() => handleTryAgain()}
        buttonName={t("TRY AGAIN")}
        buttonAriaLabel="Try again"
      />
    </div>
  );
};
const mapDispatchToProps = {
  setRevealPermissionFallBack: Actions.setRevealPermissionFallBack,
};

const mapStateToProps = (state) => {
  return {
    revealPermissionFallBack: state.ACCOUNT.revealPermissionFallBack,
    regionId: state.ACCOUNT.regionId,
    accountNumber: state.ACCOUNT.accountNumber,
    firstName: state.ACCOUNT.firstName,
    surname: state.ACCOUNT.surname,
    emailAddress: state.ACCOUNT.emailAddress,
    phoneNumber: state.ACCOUNT.accountUserTokenDetails.phoneNumber,
    windowSize: state.ACCOUNT.windowSize,
  };
};
SomethingWentWrong.propTypes = {
  regionId: PropTypes.string.isRequired,
  emailAddress: PropTypes.string,
  accountNumber: PropTypes.string,
  firstName: PropTypes.string,
  surname: PropTypes.string,
  phoneNumber: PropTypes.string,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  setRevealPermissionFallBack: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(SomethingWentWrong);
